export default "__VITE_ASSET__DusxSDxm__"